import React, { useRef, useEffect, useState, useContext } from 'react';
import { AppContext } from '../context/AppContext';
import * as d3 from 'd3';
import { mainWorkflow } from '../components/mainWorkflow.js';
import TopBar from '../components/TopBar';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import chalk from 'chalk';
import ChainedLM0 from '../assets/ChainedLM0.jpeg';
import { audio, header } from 'framer-motion/client';
import threedots from '../assets/threedots.gif';
import BreathingIcon from '../components/BreathingIcon';
import BreathingIconStatic from '../components/BreathingIconStatic';
import LogViewer from '../components/LogViewer';
import deepseek from '../assets/deepseek.png';
import gemini from '../assets/gemini.png';
import claude from '../assets/claude.png'; // Add Claude logo import
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Fab from '@mui/material/Fab';
import CircularProgress from '@mui/material/CircularProgress';
import DoneIcon from '@mui/icons-material/Done';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import ArrowUpwardSharpIcon from '@mui/icons-material/ArrowUpwardSharp';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import Button from '@mui/material/Button'; // Import Button for the stop button
import StopCircleIcon from '@mui/icons-material/StopCircle';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import HttpsOutlinedIcon from '@mui/icons-material/HttpsOutlined';
import { Lock, X } from 'lucide-react';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import { AppContextisChecked } from '../context/AppContextisChecked';
import BasicModal from '../components/BasicModal.js';
// Export these variables to be used in other files
export let thinkingobj = {};
export let iter1Hook = '';

// The function used to patch or append "chatSections"
function patchOrAppendChatSections(prevChats, newObj, keysToAdd) {
    // If no chatSections yet, create the first element
    if (prevChats.length === 0) {
        localStorage.setItem('isEnabled', false);
        return [newObj];
    }
    let isEnabled = localStorage.getItem('isEnabled');
    // If localStorage 'isEnabled' is true => create new element
    if (isEnabled === 'true') {
        // console.log('patch prevChats', prevChats);
        const updated = [...prevChats];
        // console.log('patch updated', updated);
        updated.push(newObj);
        // console.log('patch updated', updated);
        localStorage.setItem('isEnabled', false);
        return updated;
    }
    // Otherwise, patch the last element in the array
    const updated = [...prevChats];
    // console.log('patch updated', updated);
    const lastIndex = updated.length - 1;
    // console.log('patch lastIndex', lastIndex);
    const lastElem = updated[lastIndex];
    // console.log('patch lastElem', lastElem);
    updated[lastIndex] = { ...lastElem, ...keysToAdd };
    // console.log('patch updated[lastIndex]', updated[lastIndex]);
    return updated;
}

function Landingpage() {
    const [loadingarticles, setLoadingarticles] = useState(false);
    const [errorarticles, setErrorarticles] = useState(null);
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [inputOperator, setInputOperator] = useState('');
    const [lastQuery, setLastQuery] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingOperator, setIsLoadingOperator] = useState(false);
    const [searchStatus, setSearchStatus] = useState('');
    const [error, setError] = useState(null);
    const [currentSearchResults, setCurrentSearchResults] = useState([]);
    const [showTavilyModal, setShowTavilyModal] = useState(false);
    const [showReasoningModal, setShowReasoningModal] = useState(false);
    const [selectedMessageData, setSelectedMessageData] = useState({});
    const [hasSubmitted1, setHasSubmitted1] = useState(false);
    const [hasSubmitted2, setHasSubmitted2] = useState(false);
    const [hidearticleshook, setHidearticleshook] = useState(false);
    const [viewInputButton, setViewInputButton] = useState(false);
    const abortControllerRef = useRef(null);
    const [chatSections, setChatSections] = useState([]);
    const [selectedSuggestion, setSelectedSuggestion] = useState(null);
    const [articleshook, setArticleshook] = useState();
    const [finalSummaryhook, setFinalSummaryhook] = useState('');
    const [subtopicshook, setSubtopicshook] = useState('');
    const [iter1HookState, setIter1Hook] = useState('');
    let breathingIcon = BreathingIcon();
    const [thinkingObjState, setThinkingobj] = useState({});
    const [first_img, setFirst_img] = useState('');
    const [second_img, setSecond_img] = useState('');
    const bottomRef = useRef(null);
    const [stream, setStream] = useState(false);
    const [logEntries, setLogEntries] = useState({});
    const [passedinput, setPassedinput] = useState('');
    const [stopButton, setStopButton] = useState(false);
    const [showDeepSearchTooltip, setShowDeepSearchTooltip] = useState(false);
    const [showThinkTooltip, setShowThinkTooltip] = useState(false);
    const [showSearchwebTooltip, setShowSearchwebTooltip] = useState(false);
    const [showuseCredentialsTooltip, setShowuseCredentialsTooltip] = useState(false)
    const {
        AI_Agent_Model_apiProvider, setAI_Agent_Model_apiProvider,
        AI_Agent_Model_apiModel, setAI_Agent_Model_apiModel,
        AI_Agent_Model_apikey, setAI_Agent_Model_apikey
    } = useContext(AppContext);
    // const [AI_Agent_Model_apiProvider, setAI_Agent_Model_apiProvider] = useState(null);
    // const [AI_Agent_Model_apiModel, setAI_Agent_Model_apiModel] = useState(null);
    // const [AI_Agent_Model_apikey, setAI_Agent_Model_apikey] = useState(null)
    // console.log('AI_Agent_Model_apiProvider', AI_Agent_Model_apiProvider);
    // console.log('AI_Agent_Model_apiModel', AI_Agent_Model_apiModel);
    // console.log('AI_Agent_Model_apikey', AI_Agent_Model_apikey);
    const { auth, setAuth } = useContext(AppContextisChecked);
    // console.log('authenticated', auth)
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [focused, setFocused] = useState(false);
    // Add animation keyframes for the processing text
    useEffect(() => {
        const styleSheet = document.createElement("style");
        styleSheet.id = "processing-animation-style";
        styleSheet.type = "text/css";
        styleSheet.innerText = `
            @keyframes pulseScale {
                0% { transform: scale(1); }
                50% { transform: scale(1.05); }
                100% { transform: scale(1); }
            }
            .processing-text-animation {
                display: inline-block;
                animation: pulseScale 1.5s infinite ease-in-out;
            }
            @keyframes slideInFromLeft {
                0% { 
                    transform: translateX(-10%);
                    opacity: 0;
                }
                100% { 
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            @keyframes slideInFromRight {
                0% { 
                    transform: translateX(+100%);
                    opacity: 0;
                }
                100% { 
                    transform: translateX(0);
                    opacity: 1;
                }
            }
            @keyframes fadeIn {
                from {
                    opacity: 0;
                }
                to {
                    opacity: 1;
                }
            }
        `;
        // Only add if it doesn't exist yet
        if (!document.getElementById("processing-animation-style")) {
            document.head.appendChild(styleSheet);
        }

        // Clean up
        return () => {
            if (document.getElementById("processing-animation-style")) {
                document.head.removeChild(styleSheet);
            }
        };
    }, []);

    useEffect(() => {
        let timer;
        if (stopButton) {
            // Reset the state after 2 seconds (2000ms)
            timer = setTimeout(() => setStopButton(false), 2000);
        }
        return () => clearTimeout(timer);
    }, [stopButton]);
    const [isChecked, setIsChecked] = useState(() => {
        try {
            const storedValue = localStorage.getItem('isChecked');
            return storedValue !== null ? JSON.parse(storedValue) : false;
        } catch (e) {
            // console.error('Error parsing isChecked from localStorage:', e);
            return false; // Default to false if parsing fails
        }
    });

    // Effect to listen for changes in localStorage from other tabs
    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === 'isChecked') {
                try {
                    const newValue = event.newValue !== null ? JSON.parse(event.newValue) : false;
                    setIsChecked(newValue);
                    // console.log('isChecked updated from storage event:', newValue);
                } catch (e) {
                    // console.error('Error parsing isChecked from storage event:', e);
                    setIsChecked(false);
                }
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);
    const {
        apiError, setAPIError,
        Actor_Model_apiProvider, setActor_Model_apiProvider,
        Critic_Model_apiProvider, setCritic_Model_apiProvider,
        Actor_Model_apiModel, setActor_Model_apiModel,
        Critic_Model_apiModel, setCritic_Model_apiModel,
        Actor_Model_apikey, setActor_Model_apikey,
        Critic_Model_apikey, setCritic_Model_apikey,
        temperature_val_Actor_Model_apiProvider, setTemperature_val_Actor_Model_apiProvider,
        temperature_val_Critic_Model_apiProvider, setTemperature_val_Critic_Model_apiProvider
    } = useContext(AppContext);
    let first_model = Actor_Model_apiProvider;
    // console.log('ratcoin', first_img, Actor_Model_apiProvider)
    useEffect(() => {
        if (first_model === 'Deepseek') {
            setFirst_img('Deepseek');
        } else if (first_model === 'Google Gemini') {
            setFirst_img('Google Gemini');
        } else if (first_model === 'Anthropic') {
            setFirst_img('Anthropic');
        }
    }, [first_model]);

    let second_model = Critic_Model_apiProvider;
    useEffect(() => {
        if (second_model === 'Deepseek') {
            setSecond_img('Deepseek');
        } else if (second_model === 'Google Gemini') {
            setSecond_img('Google Gemini');
        } else if (second_model === 'Anthropic') {
            setSecond_img('Anthropic');
        }
    }, [second_model]);

    const [useCredentials, setUseCredentials] = useState(false)

    const [screenshotUrl, setScreenshotUrl] = useState(null);
    const [cachedScreenshotUrl, setCachedScreenshotUrl] = useState(null);
    const [stopScreenshotUrl, setStopScreenshotUrl] = useState(false);
    const [isSendHovered, setIsSendHovered] = useState(false);
    const [DeepSearch, setDeepSearch] = useState(false);
    const [Think, setThink] = useState(false);
    const [Searchweb, setSearchweb] = useState(false);
    const [changeLogViewer_pos, setChangeLogViewer_pos] = useState(false);
    const CACHE_NAME = 'screenshot-cache';

    const fetchScreenshot = async () => {
        try {
            const url = 'https://browserusedom.duckdns.org/screenshot';
            const response = await fetch(url);
            if (!response.ok) {
                setScreenshotUrl(null);
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const blob = await response.blob();
            if (!blob || blob.size === 0) {
                setScreenshotUrl(null);
                throw new Error("Received empty image data");
            }
            const imageUrl = URL.createObjectURL(blob);
            setScreenshotUrl(imageUrl);
            const cache = await caches.open(CACHE_NAME);
            await cache.put(url, new Response(blob, {
                headers: { 'Content-Type': 'image/png' }
            }));
            // console.log('Screenshot cached');
            const cachedImageUrl = URL.createObjectURL(blob);
            setCachedScreenshotUrl(cachedImageUrl);
        } catch (error) {
            // console.error("Error fetching screenshot:", error);
        }
    };

    useEffect(() => {
        if (hasSubmitted2) {
            fetchScreenshot();
            // fetch every 1.5 seconds
            const intervalId = setInterval(fetchScreenshot, 1500);
            return () => clearInterval(intervalId);
        }
    }, [hasSubmitted2]);

    const stopProcess = async () => {
        try {
            const response = await fetch('https://browserusedom.duckdns.org/stop_process', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            setIsLoadingOperator(false);
            setStopScreenshotUrl(false);
            setStopButton(true)
            // console.log('Stop process response:', data);
        } catch (error) {
            // console.error('Error stopping process:', error);
        }
    };

    const stopProcessResearch = async () => {
        try {
            // Abort any ongoing API requests
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
                abortControllerRef.current = null;
            }
            // Reset states related to research
            //setHasSubmitted1(false);
            setIsLoading(false);
            setAPIError(null); // Reset any API error
            setThinkingobj()
            // console.log("Research process stopped successfully");
        } catch (error) {
            // console.error("Error stopping research process:", error);
            setAPIError(error.message || 'Failed to stop research process');
        }
    };

    const scrollToBottom = () => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        if (bottomRef.current) {
            const scrollToElement = (element) => {
                const startPosition = window.pageYOffset || document.documentElement.scrollTop;
                const targetPosition = element.getBoundingClientRect().top + startPosition;
                const distance = targetPosition - startPosition;
                const duration = 1500; // 1.5 seconds
                let startTime = null;

                function animation(currentTime) {
                    if (startTime === null) startTime = currentTime;
                    const timeElapsed = currentTime - startTime;
                    const progress = Math.min(timeElapsed / duration, 1);

                    // Simple easeInOutQuad function - smooth without bouncing
                    const easeProgress = progress < 0.5
                        ? 2 * progress * progress
                        : 1 - Math.pow(-2 * progress + 2, 2) / 2;

                    // window.scrollTo(0, startPosition + distance * easeProgress);

                    if (timeElapsed < duration) {
                        requestAnimationFrame(animation);
                    }
                }

                // Start the animation
                requestAnimationFrame(animation);
            };

            // Execute the scroll
            scrollToElement(bottomRef.current);
        }
    }, [chatSections]);

    const handleSubmituseCredentials = () => setUseCredentials(prevState => !prevState);

    const handleSubmitDeepSearch = () => setDeepSearch(prevState => !prevState);
    const handleSubmitThink = () => setThink(prevState => !prevState);
    const handleSubmitSearchweb = () => setSearchweb(prevState => !prevState)
    const handleSubmit1 = async (e) => {
        e.preventDefault();
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();
        setAPIError(false)
        setThinkingobj((prev) => {
            localStorage.setItem('isEnabled', true);
            return {};
        });
        let isEnabled = localStorage.getItem('isEnabled');
        setHasSubmitted1(true);
        setThinkingobj((prevState) => {
            const newObj = { ...prevState, query: input };
            setChatSections((prevChats) => {
                return patchOrAppendChatSections(prevChats, newObj);
            });
            return newObj;
        });
        const userMessage = { role: 'user', content: input };
        setMessages((prev) => [...prev, userMessage]);
        setInput('');
        setIsLoading(true);
        (async () => {
            try {
                await mainWorkflow(
                    Searchweb,
                    setLoadingarticles,
                    setErrorarticles,
                    DeepSearch,
                    Think,
                    input,
                    first_img,
                    setThinkingobj,
                    setSubtopicshook,
                    articleshook,
                    setArticleshook,
                    setFinalSummaryhook,
                    setIter1Hook,
                    chatSections,
                    setChatSections,
                    thinkingobj,
                    abortControllerRef.current.signal, // FIXED: This should be the signal parameter
                    setIsLoading,                      // FIXED: This should be setIsLoading
                    apiError,
                    setAPIError,
                    Actor_Model_apiProvider,
                    setActor_Model_apiProvider,
                    Critic_Model_apiProvider,
                    setCritic_Model_apiProvider,
                    Actor_Model_apiModel,
                    setActor_Model_apiModel,
                    Critic_Model_apiModel,
                    setCritic_Model_apiModel,
                    Actor_Model_apikey,
                    setActor_Model_apikey,
                    Critic_Model_apikey,
                    setCritic_Model_apikey,
                    temperature_val_Actor_Model_apiProvider,
                    setTemperature_val_Actor_Model_apiProvider,
                    temperature_val_Critic_Model_apiProvider,
                    setTemperature_val_Critic_Model_apiProvider
                );
            } catch (error) {
                if (error instanceof Error && error.name === 'AbortError') {
                    // console.log('Research process was aborted');
                } else {
                    // console.log('Unhandled error in mainWorkflow:', error);
                    setAPIError(error.message || 'An unexpected error occurred');
                }
            }
        })();
    };

    const handleSubmit2 = async (e) => {
        e.preventDefault();
        await stopProcess()
        setIsLoadingOperator(true)
        setLogEntries({});
        setChangeLogViewer_pos(true);

        setStream(true);
        setPassedinput(inputOperator);
        setHasSubmitted2(true);

        const taskData = {
            task: useCredentials ? `Task: ${inputOperator}. Use credentials from username and password to achieve task.` : `Task: ${inputOperator}`,
            AI_Agent_Model_apiProvider: AI_Agent_Model_apiProvider,
            AI_Agent_Model_apiModel: AI_Agent_Model_apiModel,
            AI_Agent_Model_apikey: AI_Agent_Model_apikey,
            username: username,
            password: password,
        };
        fetch('https://browserusedom.duckdns.org/store_task', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(taskData)
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => {
                // console.log('Task successfully sent to server:', data);
            })
            .catch((error) => {
                // console.error('Error sending task to server:', error);
            });


        setInputOperator('')
    };
    useEffect(() => {
        if (apiError && isLoading) {
            setThinkingobj((prevState) => {
                const newObj = { ...prevState, timout_err: true };
                setChatSections((prev) => {
                    return patchOrAppendChatSections(prev, newObj, { timout_err: true });
                });
                return newObj;
            });
        }
    }, [apiError])
    const linkedinfunc = () => {
        setInputOperator('Go to https://www.linkedin.com, create a linkedin.com post saying "Your Post Here".')
        setUseCredentials(true)
    }
    const xfunc = () => {
        setInputOperator('Go to https://x.com/, create a post saying "Your Post Here".')
        setUseCredentials(true)
    }
    const instafunc = () => {
        setInputOperator('Go to https://www.instagram.com/ and log in. In the search bar, search for the name "sannamrin". Check out her posts.')
        setUseCredentials(true)
    }
    const teslafunc = () => {
        setInputOperator('Find out the latest price of TESLA Stock.')
        setUseCredentials(false)
    }
    const researchAfunc = () => {
        setInput('Analyze how precision medicine advances will transform healthcare delivery, insurance models, and health equity across developed and developing nations.')
    }
    const researchBfunc = () => {
        setInput('Examine how the rise of passive investing strategies is reshaping market efficiency, corporate governance, and wealth distribution.')
    }
    const researchCfunc = () => {
        setInput('Explore how large language models are reshaping information ecosystems, labor markets, and educational paradigms across societies.')
    }
    const researchDfunc = () => {
        setInput('Examine how digital disinformation campaigns are transforming electoral systems, democratic institutions, and social cohesion.')
    }
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'start', opacity: 1, marginTop: '6%' }}>
            <TopBar setIsChecked={setIsChecked} />
            {isChecked && isLoadingOperator && stopScreenshotUrl && screenshotUrl && (
                <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', marginTop: '-40px' }}>
                    <img src={screenshotUrl} style={{ width: '50vw', height: '80vh', border: '1px solid #ccc', borderRadius: '8px', boxShadow: 'rgb(0 0 0 / 10%) 0px 1px 20px 1px' }} />
                </div>
            )}
            {isChecked && isLoadingOperator && stopScreenshotUrl && !screenshotUrl && cachedScreenshotUrl && (
                <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', marginTop: '-40px' }}>
                    <img src={cachedScreenshotUrl} style={{ width: '50vw', height: '80vh', border: '1px solid #ccc', borderRadius: '8px', boxShadow: 'rgb(0 0 0 / 10%) 0px 1px 20px 1px' }} />
                </div>
            )}
            {/* {isChecked && isLoadingOperator && stopScreenshotUrl && (
                <div style={{ display: 'flex', flexDirection: 'row', textAlign: 'center', alignItems: 'center', margin: '1rem', fontFamily: 'sans-serif' }}>
                    <span style={{ marginRight: '18px' }}><CircularProgress size="30px" /></span> Loading...
                </div>
            )} */}
            {isChecked && isLoadingOperator && !stopScreenshotUrl && (
                <div style={{ width: '60vw', height: '13vh', border: '1px solid #ccc', borderRadius: '8px', boxShadow: 'rgb(0 0 0 / 10%) 0px 1px 20px 1px', display: 'flex', flexDirection: 'row', textAlign: 'center', alignItems: 'center', justifyContent: 'center', margin: '1rem', fontFamily: 'sans-serif' }}>
                    <span style={{ marginRight: '18px' }}><CircularProgress size="30px" /></span> Loading Screen
                </div>
            )}
            {!isChecked && !hasSubmitted1 && (
                <div style={{ textAlign: 'center', marginTop: '1%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                        <img src={ChainedLM0} style={{ height: '64px', marginLeft: '10px', borderRadius: '15px' }} />
                        <div style={{ fontFamily: 'sans-serif', display: 'inline-block', padding: '0.675rem 1rem', backgroundColor: 'rgb(17 24, 39)', color: 'white', borderRadius: '9999px', fontSize: '0.875rem', fontWeight: 600, marginBottom: '-0.2em' }}>
                            Powered by ChainedLLM
                        </div>
                    </div>
                    <h1 style={{ fontSize: '3rem', fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif', color: 'rgb(17 24, 39)', marginBottom: '1rem', letterSpacing: '-0.025em', fontWeight: 200, width: '78%', marginLeft: 'auto', marginRight: 'auto' }}>
                        Your AI Powered Content Research Assistant
                    </h1>
                    <p style={{ fontFamily: 'sans-serif', fontSize: '1.25rem', color: 'rgb(75 85, 99 / 58%)', fontWeight: 100, maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.625 }}>
                        Do research for content in seconds, going viral.
                    </p>
                </div>
            )}
            {/* {!isChecked && !isLoading && (
                <div style={{ textAlign: 'center', }}>
                    <div style={{ width: '80vw', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', padding: '16px', background: '#f3f4f6' }}>
                        <div onClick={researchAfunc} style={{ borderLeft: '13px solid rgba(107, 113, 125, 0.75)', borderRight: '13px solid rgba(107, 113, 125, 0.75)', borderTop: '2px solid rgba(107, 113, 125, 0.75)', borderBottom: '2px solid rgba(107, 113, 125, 0.75)', borderRadius: '4px', padding: '16px', backgroundColor: 'white', cursor: 'pointer', }}>
                            <p style={{ fontFamily: 'sans-serif', fontSize: '14.5px', color: 'rgb(75 85, 99 / 58%)', fontWeight: 100, maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.625, }}>
                                Analyze how precision medicine advances will transform healthcare delivery, insurance models, and health equity across developed and developing nations.
                            </p>
                        </div>
                        <div onClick={researchBfunc} style={{ borderLeft: '13px solid rgba(107, 113, 125, 0.75)', borderRight: '13px solid rgba(107, 113, 125, 0.75)', borderTop: '2px solid rgba(107, 113, 125, 0.75)', borderBottom: '2px solid rgba(107, 113, 125, 0.75)', borderRadius: '4px', padding: '16px', backgroundColor: 'white', cursor: 'pointer', }}>
                            <p style={{ fontFamily: 'sans-serif', fontSize: '14.5px', color: 'rgb(75 85, 99 / 58%)', fontWeight: 100, maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.625, }}>
                                Examine how the rise of passive investing strategies is reshaping market efficiency, corporate governance, and wealth distribution.
                            </p>
                        </div>
                        <div onClick={researchCfunc} style={{ borderLeft: '13px solid rgba(107, 113, 125, 0.75)', borderRight: '13px solid rgba(107, 113, 125, 0.75)', borderTop: '2px solid rgba(107, 113, 125, 0.75)', borderBottom: '2px solid rgba(107, 113, 125, 0.75)', borderRadius: '4px', padding: '16px', backgroundColor: 'white', cursor: 'pointer', }}>
                            <p style={{ fontFamily: 'sans-serif', fontSize: '14.5px', color: 'rgb(75 85, 99 / 58%)', fontWeight: 100, maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.625, }}>
                                Explore how large language models are reshaping information ecosystems, labor markets, and educational paradigms across societies.
                            </p>
                        </div>
                        <div onClick={researchDfunc} style={{ borderLeft: '13px solid rgba(107, 113, 125, 0.75)', borderRight: '13px solid rgba(107, 113, 125, 0.75)', borderTop: '2px solid rgba(107, 113, 125, 0.75)', borderBottom: '2px solid rgba(107, 113, 125, 0.75)', borderRadius: '4px', padding: '16px', backgroundColor: 'white', cursor: 'pointer', }}>
                            <p style={{ fontFamily: 'sans-serif', fontSize: '14.5px', color: 'rgb(75 85, 99 / 58%)', fontWeight: 100, maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.625, }}>
                                Examine how digital disinformation campaigns are transforming electoral systems, democratic institutions, and social cohesion.
                            </p>
                        </div>
                    </div>
                </div>
            )} */}
            {!isChecked && (
                <form onSubmit={handleSubmit1} style={{ marginLeft: '1rem', marginRight: '1rem', bottom: hasSubmitted1 ? '0px' : 'auto', position: hasSubmitted1 ? 'fixed' : 'relative', zIndex: hasSubmitted1 ? 4 : 0 }}>
                    <div style={{ width: '47.5vw', position: 'relative', backgroundColor: 'rgb(249 250 251)', borderRadius: '25px', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)', border: '1px solid rgb(209 213 219)', paddingBottom: '52px' }}>
                        <textarea
                            value={input}
                            onChange={(e) => {
                                setInput(e.target.value);
                            }}
                            placeholder="How can I help?"
                            style={{
                                width: '82%',
                                fontSize: 'large',
                                padding: '1.25rem',
                                paddingRight: '8rem',
                                borderRadius: '25px',
                                border: '2px solid transparent',
                                backgroundColor: 'transparent',
                                resize: 'none',
                                height: input?'200px':'92px',
                                minHeight: '92px',
                                maxHeight: '200px', // Added maximum height
                                outline: 'none',
                                overflow: 'auto' // Changed to 'auto' to show scrollbar when max height is reached
                            }}
                        />
                        <div style={{ position: 'absolute', left: '1.9rem', bottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <button
                                type="button"
                                onClick={handleSubmitDeepSearch}
                                onMouseEnter={() => setShowDeepSearchTooltip(true)}
                                onMouseLeave={() => setShowDeepSearchTooltip(false)}
                                style={{
                                    padding: '5px 6px',
                                    backgroundColor: DeepSearch ? 'rgb(3 4 6 / 29%)' : 'white',
                                    color: DeepSearch ? 'rgb(17 24 39 / 96%)' : 'rgb(17 24 39 / 58%)',
                                    borderColor: '#9e9e9e29',
                                    borderRadius: '50px',
                                    fontWeight: 500,
                                    position: 'relative',
                                    overflow: 'visible',
                                    cursor: 'pointer',
                                    paddingRight: '13px',
                                    paddingLeft: '6px'
                                }}
                            >
                                <span style={{ position: 'relative', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <span style={{ marginRight: '10px' }}><ExploreOutlinedIcon /></span>
                                    <span style={{ fontWeight: '550' }}>DeepSearch</span>
                                </span>
                                {showDeepSearchTooltip && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-40px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'rgba(0, 0, 0, 0.75)',
                                        color: 'white',
                                        padding: '6px 10px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                        zIndex: 100,
                                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'
                                    }}>
                                        Enable deep search for more comprehensive research results
                                    </div>
                                )}
                            </button>
                            <button
                                type="button"
                                onClick={handleSubmitThink}
                                onMouseEnter={() => setShowThinkTooltip(true)}
                                onMouseLeave={() => setShowThinkTooltip(false)}
                                style={{
                                    padding: '5px 6px',
                                    backgroundColor: Think ? 'rgb(3 4 6 / 29%)' : 'white',
                                    color: Think ? 'rgb(17 24 39 / 96%)' : 'rgb(17 24 39 / 58%)',
                                    borderColor: '#9e9e9e29',
                                    borderRadius: '50px',
                                    fontWeight: 500,
                                    position: 'relative',
                                    overflow: 'visible',
                                    cursor: 'pointer',
                                    paddingRight: '13px',
                                    paddingLeft: '6px'
                                }}
                            >
                                <span style={{ position: 'relative', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <span style={{ marginRight: '10px' }}><EmojiObjectsOutlinedIcon /></span>
                                    <span style={{ fontWeight: '550' }}>Think</span>
                                </span>
                                {showThinkTooltip && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-40px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'rgba(0, 0, 0, 0.75)',
                                        color: 'white',
                                        padding: '6px 10px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                        zIndex: 100,
                                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'
                                    }}>
                                        Show reasoning behind subtopics
                                    </div>
                                )}
                            </button>

                            <button
                                type="button"
                                onClick={handleSubmitSearchweb}
                                onMouseEnter={() => setShowSearchwebTooltip(true)}
                                onMouseLeave={() => setShowSearchwebTooltip(false)}
                                style={{
                                    padding: '5px 6px',
                                    backgroundColor: Searchweb ? 'rgb(3 4 6 / 29%)' : 'white',
                                    color: Searchweb ? 'rgb(17 24 39 / 96%)' : 'rgb(17 24 39 / 58%)',
                                    borderColor: '#9e9e9e29',
                                    borderRadius: '50px',
                                    fontWeight: 500,
                                    position: 'relative',
                                    overflow: 'visible',
                                    cursor: 'pointer',
                                    paddingRight: '13px',
                                    paddingLeft: '6px'
                                }}
                            >
                                <span style={{ position: 'relative', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <span style={{ marginRight: '10px' }}><LanguageOutlinedIcon /></span>
                                    <span style={{ fontWeight: '550' }}>Search</span>
                                </span>
                                {showSearchwebTooltip && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-40px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'rgba(0, 0, 0, 0.75)',
                                        color: 'white',
                                        padding: '6px 10px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                        zIndex: 100,
                                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'
                                    }}>
                                        Search the web for relevant information
                                    </div>
                                )}
                            </button>
                        </div>
                        <div style={{ position: 'absolute', right: '1.9rem', bottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            {!isLoading && <button type="submit" disabled={isLoading} onMouseEnter={() => setIsSendHovered(true)} onMouseLeave={() => setIsSendHovered(false)} style={{ padding: '6px 6px 6px 6px', backgroundColor: input.length > 0 ? 'rgb(17, 24, 39)' : 'white', color: input.length > 0 ? 'white' : 'rgba(145, 145, 145, 1)', border: 'none', borderRadius: '50px', fontWeight: 500, position: 'relative', overflow: 'hidden', cursor: 'pointer', transition: 'transform 0.1s ease-in-out', transform: input.length > 0 ? isSendHovered ? 'scale(1.07)' : 'scale(1)' : 'scale(1)' }}>
                                <span style={{ padding: '3.5px', transition: 'transform 0.1s ease-in-out', transform: input.length > 0 ? isSendHovered ? 'scale(1.07)' : 'scale(1)' : 'scale(1)' }}><ArrowUpwardSharpIcon /></span>
                            </button>}
                            {isLoading && <div onMouseEnter={() => setIsSendHovered(true)} onMouseLeave={() => setIsSendHovered(false)} style={{ textAlign: 'center', transition: 'transform 0.1s ease-in-out', transform: isSendHovered ? 'scale(1.07)' : 'scale(1)' }} >
                                <span
                                    onClick={stopProcessResearch}
                                    disabled={!hasSubmitted1}
                                    style={{
                                        color: stopButton ? 'red' : 'black',
                                        cursor: 'pointer',
                                        width: '30px',
                                    }}
                                >
                                    <StopCircleIcon fontSize='large' />
                                </span>
                            </div>}
                        </div>
                    </div>
                </form>
            )}
            {isChecked && !screenshotUrl && !hasSubmitted2 && (
                <div style={{ textAlign: 'center', marginTop: '3%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                        <img src={ChainedLM0} style={{ height: '64px', marginLeft: '10px', borderRadius: '15px' }} />
                        <div style={{ fontFamily: 'sans-serif', display: 'inline-block', padding: '0.675rem 1rem', backgroundColor: 'rgb(17 24, 39)', color: 'white', borderRadius: '9999px', fontSize: '0.875rem', fontWeight: 600, marginBottom: '-0.2em' }}>
                            Powered by ChainedLLM
                        </div>
                    </div>
                    <h1 style={{ fontSize: '3rem', fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif', color: 'rgb(17 24, 39)', marginBottom: '1rem', letterSpacing: '-0.025em', fontWeight: 200, width: '78%', marginLeft: 'auto', marginRight: 'auto' }}>
                        Your AI Powered Agent Operator inside Browser
                    </h1>
                    <p style={{ fontFamily: 'sans-serif', fontSize: '1.25rem', color: 'rgb(75 85, 99 / 58%)', fontWeight: 100, maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.625 }}>
                        Let your AI Agent take over your Browser!
                    </p>

                </div>
            )}
            {/* {isChecked && !isLoadingOperator && (
                <div style={{ textAlign: 'center', }}>
                    <div style={{ width: '80vw', display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px', padding: '16px', background: '#f3f4f6' }}>
                        <div onClick={linkedinfunc} style={{ borderLeft: '13px solid rgba(107, 113, 125, 0.75)', borderRight: '13px solid rgba(107, 113, 125, 0.75)', borderTop: '2px solid rgba(107, 113, 125, 0.75)', borderBottom: '2px solid rgba(107, 113, 125, 0.75)', borderRadius: '4px', padding: '16px', backgroundColor: 'white', cursor: 'pointer', }}>
                            <p style={{ fontFamily: 'sans-serif', fontSize: '14.5px', color: 'rgb(75 85, 99 / 58%)', fontWeight: 100, maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.625, }}>
                                Go to https://www.linkedin.com, create a linkedin.com post saying "Your Post Here".
                            </p>
                        </div>
                        <div onClick={xfunc} style={{ borderLeft: '13px solid rgba(107, 113, 125, 0.75)', borderRight: '13px solid rgba(107, 113, 125, 0.75)', borderTop: '2px solid rgba(107, 113, 125, 0.75)', borderBottom: '2px solid rgba(107, 113, 125, 0.75)', borderRadius: '4px', padding: '16px', backgroundColor: 'white', cursor: 'pointer', }}>
                            <p style={{ fontFamily: 'sans-serif', fontSize: '14.5px', color: 'rgb(75 85, 99 / 58%)', fontWeight: 100, maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.625, }}>
                                Go to https://x.com/, create a post saying "Your Post Here".
                            </p>
                        </div>
                        <div onClick={instafunc} style={{ borderLeft: '13px solid rgba(107, 113, 125, 0.75)', borderRight: '13px solid rgba(107, 113, 125, 0.75)', borderTop: '2px solid rgba(107, 113, 125, 0.75)', borderBottom: '2px solid rgba(107, 113, 125, 0.75)', borderRadius: '4px', padding: '16px', backgroundColor: 'white', cursor: 'pointer', }}>
                            <p style={{ fontFamily: 'sans-serif', fontSize: '14.5px', color: 'rgb(75 85, 99 / 58%)', fontWeight: 100, maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.625, }}>
                                Go to https://www.instagram.com/ and log in. In the search bar, search for the name "sannamrin". Check out her posts.
                            </p>
                        </div>
                        <div onClick={teslafunc} style={{ borderLeft: '13px solid rgba(107, 113, 125, 0.75)', borderRight: '13px solid rgba(107, 113, 125, 0.75)', borderTop: '2px solid rgba(107, 113, 125, 0.75)', borderBottom: '2px solid rgba(107, 113, 125, 0.75)', borderRadius: '4px', padding: '16px', backgroundColor: 'white', cursor: 'pointer', }}>
                            <p style={{ fontFamily: 'sans-serif', fontSize: '14.5px', color: 'rgb(75 85, 99 / 58%)', fontWeight: 100, maxWidth: '42rem', marginLeft: 'auto', marginRight: 'auto', lineHeight: 1.625, }}>
                                Find out the latest price of TESLA Stock.
                            </p>
                        </div>
                    </div>
                </div>
            )} */}
            {<LogViewer isChecked={isChecked} logEntries={logEntries} setLogEntries={setLogEntries} stopScreenshotUrl={stopScreenshotUrl} setStopScreenshotUrl={setStopScreenshotUrl} passedinput={passedinput} changeLogViewer_pos={changeLogViewer_pos} setChangeLogViewer_pos={setChangeLogViewer_pos} stopProcess={stopProcess} />}
            {isChecked && (
                <form onSubmit={handleSubmit2} style={{ marginLeft: '1rem', marginRight: '1rem', bottom: hasSubmitted2 ? '0px' : 'auto', position: hasSubmitted2 ? 'fixed' : 'relative', zIndex: hasSubmitted2 ? 1 : 0 }}>
                    <div style={{ width: '47.5vw', position: 'relative', backgroundColor: 'rgb(249 250 251)', borderRadius: '25px', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)', border: '1px solid rgb(209 213 219)', paddingBottom: '52px' }}>
                        <textarea
                            value={inputOperator}
                            onChange={(e) => {
                                setInputOperator(e.target.value)
                            }}
                            placeholder="How can I help?"
                            style={{
                                width: '82%',
                                fontSize: 'large',
                                padding: '1.25rem',
                                paddingRight: '8rem',
                                borderRadius: '25px',
                                border: '2px solid transparent',
                                backgroundColor: 'transparent',
                                resize: 'none',
                                height: inputOperator?'200px':'92px',
                                minHeight: '92px',
                                maxHeight: '200px',
                                outline: 'none',
                                overflow: 'auto'
                            }}
                        />
                        <div style={{ position: 'absolute', left: '1.9rem', bottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '5px', width: '90%' }}>
                            <button
                                type="button"
                                onClick={handleSubmituseCredentials}
                                onMouseEnter={() => setShowuseCredentialsTooltip(true)}
                                onMouseLeave={() => setShowuseCredentialsTooltip(false)}
                                style={{
                                    padding: '5px 6px',
                                    backgroundColor: useCredentials ? 'rgb(3 4 6 / 29%)' : 'white',
                                    color: useCredentials ? 'rgb(17 24 39 / 96%)' : 'rgb(17 24 39 / 58%)',
                                    borderColor: '#9e9e9e29',
                                    borderRadius: '50px',
                                    fontWeight: 500,
                                    position: 'relative',
                                    overflow: 'visible',
                                    cursor: 'pointer',
                                    paddingRight: '13px',
                                    paddingLeft: '6px'
                                }}
                            >
                                <span style={{ position: 'relative', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <span style={{ marginRight: '10px' }}><HttpsOutlinedIcon /></span>
                                    <span style={{ fontWeight: '550' }}>Use Credentials</span>
                                </span>
                                {showuseCredentialsTooltip && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-40px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'rgba(0, 0, 0, 0.75)',
                                        color: 'white',
                                        padding: '6px 10px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                        zIndex: 100,
                                        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)'
                                    }}>
                                        Use Credentials to log in to Social Media / Secured Sites
                                    </div>
                                )}
                            </button>
                            {useCredentials && <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    maxWidth: '34vw',
                                    animation: 'slideInFromLeft 0.6s ease-out forwards'
                                }}>
                                <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '50%', borderRadius: '50px', transition: 'all 0.3s ease', border: `1px solid ${focused ? '#3b82f6' : '#e5e7eb'}`, backgroundColor: focused ? '#ffffff' : '#f9fafb', boxShadow: focused ? '0 4px 6px -1px rgba(0, 0, 0, 0.1)' : 'none' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px', color: '#6b7280' }}>
                                        <AccountCircleOutlinedIcon />
                                    </div>
                                    <input
                                        type="text"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                        onFocus={() => setFocused(true)}
                                        onBlur={() => setFocused(false)}
                                        placeholder="Username"
                                        style={{ padding: '12px 16px 12px 0', backgroundColor: 'transparent', color: '#1f2937', fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500', outline: 'none', border: 'none' }}
                                    />
                                    {username && (
                                        <button
                                            onClick={() => setUsername('')}
                                            style={{ position: 'absolute', right: '12px', color: '#9ca3af', background: 'none', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <span style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', borderWidth: '0' }}>Clear input</span>
                                            <X size={16} />
                                        </button>
                                    )}
                                </div>
                                <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '46.5%', borderRadius: '50px', transition: 'all 0.3s ease', border: `1px solid ${focused ? '#3b82f6' : '#e5e7eb'}`, backgroundColor: focused ? '#ffffff' : '#f9fafb', boxShadow: focused ? '0 4px 6px -1px rgba(0, 0, 0, 0.1)' : 'none' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px', color: '#6b7280' }}>
                                        <KeyOutlinedIcon />
                                    </div>
                                    <input
                                        type={"password"}
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        onFocus={() => setFocused(true)}
                                        onBlur={() => setFocused(false)}
                                        placeholder="Password"
                                        style={{ padding: '12px 16px 12px 0', backgroundColor: 'transparent', color: '#1f2937', fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500', outline: 'none', border: 'none' }}
                                    />
                                    {password && (
                                        <button
                                            onClick={() => setPassword('')}
                                            style={{ position: 'absolute', right: '12px', color: '#9ca3af', background: 'none', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <span style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', borderWidth: '0' }}>Clear input</span>
                                            <X size={16} />
                                        </button>
                                    )}
                                </div>
                            </div>}
                        </div>
                        <div style={{ position: 'absolute', right: '1.9rem', bottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            {!isLoadingOperator && <button type="submit" disabled={isLoadingOperator} onMouseEnter={() => setIsSendHovered(true)} onMouseLeave={() => setIsSendHovered(false)} style={{ padding: '6px 6px 6px 6px', backgroundColor: inputOperator?.length > 0 ? 'rgb(17, 24, 39)' : 'white', color: inputOperator?.length > 0 ? 'white' : 'rgba(145, 145, 145, 1)', border: 'none', borderRadius: '50px', fontWeight: 500, position: 'relative', overflow: 'hidden', cursor: 'pointer', transition: 'transform 0.1s ease-in-out', transform: inputOperator?.length > 0 ? isSendHovered ? 'scale(1.07)' : 'scale(1)' : 'scale(1)' }}>
                                <span style={{ padding: '3.5px', transition: 'transform 0.1s ease-in-out', transform: inputOperator?.length > 0 ? isSendHovered ? 'scale(1.07)' : 'scale(1)' : 'scale(1)' }}><ArrowUpwardSharpIcon /></span>
                            </button>}
                            {isLoadingOperator && <div onMouseEnter={() => setIsSendHovered(true)} onMouseLeave={() => setIsSendHovered(false)} style={{ textAlign: 'center', transition: 'transform 0.1s ease-in-out', transform: isSendHovered ? 'scale(1.07)' : 'scale(1)' }} >
                                <span
                                    onClick={stopProcess}
                                    style={{
                                        color: stopButton ? 'red' : 'black',
                                        cursor: 'pointer',
                                        width: '30px',
                                    }}
                                >
                                    <StopCircleIcon fontSize='large' />
                                </span>
                            </div>}
                        </div>
                    </div>
                </form>
            )}
            {hasSubmitted1 && (
                <div style={{ display: !isChecked ? 'block' : 'none', width: '100%', maxWidth: '80vw', marginLeft: '1rem', marginRight: '1rem', marginBottom: hasSubmitted1 ? '19rem' : '8rem', marginTop: hasSubmitted1 ? '4.5rem' : '10rem' }}>
                    {Array.isArray(chatSections) &&
                        chatSections.map((section, index) => (
                            <div key={index} style={{ marginBottom: '2rem', borderBottom: '1px solid rgba(75,85,99,0.2)', paddingBottom: '2rem' }}>
                                {section?.subtopics &&
                                    <div style={{ color: "white", backgroundColor: "#121212", width: "100%", minHeight: "32vh", marginBottom: "0vh", marginTop: "-5vh", position: section?.subtopics ? "relative" : "absolute", borderRadius: "8px", overflow: "hidden", boxShadow: "0 0 15px rgba(0,0,0,0.5)", fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" }}>
                                        {/* Ambient background effect */}
                                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: 0.15, background: 'radial-gradient(circle at 50% 50%, #3a3a3a 0%, #121212 70%)', zIndex: 0 }}></div>

                                        {/* Subtle grid background */}
                                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: 0.08, backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.1) 1px, transparent 1px)', backgroundSize: '20px 20px', zIndex: 0 }}></div>

                                        {/* Status bar */}
                                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, padding: '8px 15px', background: 'rgba(0,0,0,0.6)', borderBottom: '1px solid rgba(255,255,255,0.08)', zIndex: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <div style={{ fontSize: '12px', fontWeight: 'bold', color: '#cccccc', letterSpacing: '0.5px' }}>Research Process</div>

                                            {section?.loading && <div className="processing-text-animation" style={{ fontSize: '11px', color: '#999', display: 'flex', alignItems: 'center' }}>
                                                <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: section?.finalSummary ? '#34de34' : '#34de34', marginRight: '6px' }} />
                                                <span >Processing...</span>
                                            </div>}
                                            {section?.error && <div style={{ fontSize: '11px', color: '#999', display: 'flex', alignItems: 'center' }}>
                                                <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: section?.finalSummary ? '#34de34' : '#34de34', marginRight: '6px' }} />
                                                <span >Processing Stopped</span>
                                            </div>}
                                            {section?.stage === "Completed" && <div style={{ fontSize: '11px', color: '#999', display: 'flex', alignItems: 'center' }}>
                                                <div style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: section?.finalSummary ? '#34de34' : '#34de34', marginRight: '6px' }} />
                                                <span >Processing Complete</span>
                                            </div>}

                                        </div>

                                        <div style={{ position: 'relative', zIndex: 1, paddingTop: '32px' }}>
                                            <Timeline position="alternate">
                                                <TimelineItem>
                                                    {section?.subtopics &&
                                                        <TimelineOppositeContent color="text.secondary">
                                                            <div style={{ fontSize: "13px", color: "white", backgroundColor: "rgba(170, 170, 170, 0.1)", borderLeft: "2px solid #aaaaaa", padding: "8px 12px", borderRadius: "4px" }}>
                                                                <div style={{ fontWeight: "bold", marginBottom: "4px", color: "#e0e0e0" }}>Query Analysis</div>
                                                                <div style={{ fontSize: "11px", opacity: 0.8, color: "#cccccc" }}>Processing and understanding the structure of the input query</div>
                                                            </div>
                                                        </TimelineOppositeContent>
                                                    }
                                                    <TimelineSeparator>
                                                        {section?.subtopics &&
                                                            <div style={{ position: "relative", zIndex: 2 }}>
                                                                <TimelineDot sx={{ bgcolor: "#aaaaaa", boxShadow: "0 0 5px rgba(170, 170, 170, 0.5)" }} />
                                                                <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, border: "2px solid rgba(170, 170, 170, 0.3)", borderRadius: "50%", transform: "scale(1.5)", opacity: 0.6 }}></div>
                                                            </div>
                                                        }
                                                        {section?.subtopics &&
                                                            <TimelineConnector sx={{ bgcolor: "#aaaaaa", width: "2px" }} />
                                                        }
                                                    </TimelineSeparator>
                                                    {section?.subtopics &&
                                                        <TimelineContent>
                                                            <div style={{ fontSize: "13px", color: "#e0e0e0", fontWeight: "bold", marginBottom: "4px" }}>
                                                                Semantic Decomposition
                                                            </div>
                                                            <div style={{ fontSize: "11px", color: "#cccccc" }}>
                                                                Breaking down complex query into core components
                                                            </div>
                                                        </TimelineContent>
                                                    }
                                                </TimelineItem>

                                                {section?.articles?.length > 0 &&
                                                    <TimelineItem>
                                                        <TimelineOppositeContent color="text.secondary">
                                                            <div style={{ fontSize: "13px", color: "white", backgroundColor: "rgba(170, 170, 170, 0.1)", borderLeft: "2px solid #aaaaaa", padding: "8px 12px", borderRadius: "4px" }}>
                                                                <div style={{ fontWeight: "bold", marginBottom: "4px", color: "#e0e0e0" }}>External Knowledge</div>
                                                                <div style={{ fontSize: "11px", opacity: 0.8, color: "#cccccc" }}>Retrieving relevant information from Google search results</div>
                                                            </div>
                                                        </TimelineOppositeContent>
                                                        <TimelineSeparator>
                                                            <div style={{ position: "relative", zIndex: 2 }}>
                                                                <TimelineDot sx={{ bgcolor: "#999999", boxShadow: "0 0 5px rgba(153, 153, 153, 0.5)" }} />
                                                                <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, border: "2px solid rgba(153, 153, 153, 0.3)", borderRadius: "50%", transform: "scale(1.5)", opacity: 0.6 }}></div>
                                                            </div>
                                                            <TimelineConnector sx={{ bgcolor: "#999999", width: "2px" }} />
                                                        </TimelineSeparator>
                                                        <TimelineContent>
                                                            <div style={{ fontSize: "13px", color: "#e0e0e0", fontWeight: "bold", marginBottom: "4px" }}>
                                                                Knowledge Retrieval
                                                            </div>
                                                            <div style={{ fontSize: "11px", color: "#cccccc" }}>
                                                                Analyzing and extracting insights from sources
                                                            </div>
                                                        </TimelineContent>
                                                    </TimelineItem>
                                                }

                                                <TimelineItem>
                                                    {section?.iterations?.[0].actorOutput &&
                                                        <TimelineOppositeContent color="text.secondary">
                                                            <div style={{ fontSize: "13px", color: "white", backgroundColor: "rgba(170, 170, 170, 0.1)", borderLeft: "2px solid #aaaaaa", padding: "8px 12px", borderRadius: "4px" }}>
                                                                <div style={{ fontWeight: "bold", marginBottom: "4px", color: "#e0e0e0" }}>Multi-Model Collaboration</div>
                                                                <div style={{ fontSize: "11px", opacity: 0.8, color: "#cccccc" }}>LLMs iteratively refining and cross-validating analysis</div>
                                                            </div>
                                                        </TimelineOppositeContent>
                                                    }
                                                    <TimelineSeparator>
                                                        {section?.iterations?.[0].actorOutput &&
                                                            <div style={{ position: "relative", zIndex: 2 }}>
                                                                <TimelineDot sx={{ bgcolor: "#888888", boxShadow: "0 0 5px rgba(136, 136, 136, 0.5)" }} />
                                                                <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, border: "2px solid rgba(136, 136, 136, 0.3)", borderRadius: "50%", transform: "scale(1.5)", opacity: 0.6 }}></div>
                                                            </div>
                                                        }
                                                        {section?.iterations?.[0].actorOutput &&
                                                            <TimelineConnector sx={{ bgcolor: "#888888", width: "2px" }} />
                                                        }
                                                    </TimelineSeparator>
                                                    {section?.iterations?.[0].actorOutput &&
                                                        <TimelineContent>
                                                            <div style={{ fontSize: "13px", color: "#e0e0e0", fontWeight: "bold", marginBottom: "4px" }}>
                                                                Deliberative Process
                                                            </div>
                                                            <div style={{ fontSize: "11px", color: "#cccccc" }}>
                                                                Reasoning through contradictions and evidence
                                                            </div>
                                                        </TimelineContent>
                                                    }
                                                </TimelineItem>

                                                <TimelineItem>
                                                    {section?.finalSummary &&
                                                        <TimelineOppositeContent color="text.secondary">
                                                            <div style={{ fontSize: "13px", color: "white", backgroundColor: "rgba(170, 170, 170, 0.1)", borderLeft: "2px solid #aaaaaa", padding: "8px 12px", borderRadius: "4px" }}>
                                                                <div style={{ fontWeight: "bold", marginBottom: "4px", color: "#e0e0e0" }}>Response Synthesis</div>
                                                                <div style={{ fontSize: "11px", opacity: 0.8, color: "#cccccc" }}>Distilling iterative discussion into coherent output</div>
                                                            </div>
                                                        </TimelineOppositeContent>
                                                    }
                                                    <TimelineSeparator>
                                                        {section?.finalSummary &&
                                                            <div style={{ position: "relative", zIndex: 2 }}>
                                                                <TimelineDot sx={{ bgcolor: "#777777", boxShadow: "0 0 5px rgba(119, 119, 119, 0.5)" }} />
                                                                <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, border: "2px solid rgba(119, 119, 119, 0.3)", borderRadius: "50%", transform: "scale(1.5)", opacity: 0.6 }}></div>
                                                            </div>
                                                        }
                                                    </TimelineSeparator>
                                                    {section?.finalSummary &&
                                                        <TimelineContent>
                                                            <div style={{ fontSize: "13px", color: "#e0e0e0", fontWeight: "bold", marginBottom: "4px" }}>
                                                                Final Summary
                                                            </div>
                                                            <div style={{ fontSize: "11px", color: "#cccccc" }}>
                                                                Comprehensive analysis with high confidence
                                                            </div>
                                                        </TimelineContent>
                                                    }
                                                </TimelineItem>
                                            </Timeline>
                                        </div>

                                        {/* Progress indicator at bottom */}
                                        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '3px', background: '#1a1a1a', zIndex: 1 }}>
                                            <div style={{ height: '100%', background: 'linear-gradient(90deg, #aaaaaa, #999999, #888888, #777777, #666666)', width: `${section?.finalSummary ? '100%' : section?.iterations?.[0].actorOutput ? '75%' : section?.articles?.articles?.length > 0 ? '50%' : section?.subtopics ? '25%' : '0%'}` }} />
                                        </div>
                                    </div>
                                }
                                <div style={{ marginTop: '1.5rem' }}>
                                    <p>
                                        <span style={{ fontSize: '19px', color: 'rgb(75,85,99)', fontWeight: 600 }}>
                                            # Question:{' '}
                                            <span style={{ fontSize: '17px', color: 'rgb(75,85,99)', fontWeight: 50 }}>{section.query || ''}</span>
                                        </span>
                                    </p>
                                </div>
                                {section?.searchResults?.length > 0 && (
                                    <div style={{}}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                <svg style={{ width: '1.25rem', height: '1.25rem', color: 'rgb(75,85,99)' }} viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9.5a2.5 2.5 0 00-2.5-2.5H14" />
                                                </svg>
                                                <h3 style={{ fontSize: '19px', fontWeight: 600, color: 'rgb(75,85,99)' }}>Sources</h3>
                                            </div>
                                        </div>
                                        <div style={{ display: 'flex', gap: '1rem', overflowX: 'auto', paddingBottom: '1rem' }}>
                                            {section.searchResults?.map((result, idx) => (
                                                <div key={idx} style={{ flexShrink: 0, width: '300px', backgroundColor: 'rgba(75,85,99,0.05)', border: '1px solid rgba(75,85,99,0.2)', borderRadius: '0.75rem', overflow: 'hidden' }}>
                                                    <div style={{ height: '10rem', backgroundColor: 'rgba(75,85,99,0.1)', position: 'relative' }}></div>
                                                    <div style={{ padding: '1rem' }}>
                                                        <a href={result.url} target="_blank" rel="noopener noreferrer" style={{ fontSize: '16.5px', fontWeight: 500, color: 'rgb(37,99,235)', textDecoration: 'none' }}>{result.title}</a>
                                                        <p style={{ fontSize: '16.5px', color: 'rgb(75,85,99)', marginTop: '0.5rem' }}></p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                                {!section?.subtopics && (
                                    <div style={{}}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                            <BreathingIcon />
                                            <h3 style={{ fontSize: '19px', fontWeight: 600, color: 'rgb(75,85,99)', position: 'relative' }}>
                                                Thinking
                                                <img src={threedots} style={{ width: '30px', height: '30px', marginLeft: '-2px', position: 'absolute' }} />
                                            </h3>
                                        </div>
                                    </div>
                                )}
                                {section?.subtopics && (
                                    <div style={{}}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                            <BreathingIconStatic />
                                            <h3 style={{ fontSize: '19px', fontWeight: 600, color: 'rgb(75,85,99)' }}>Thinking</h3>
                                        </div>
                                        <div style={{ fontSize: '16.5px', color: 'rgb(75,85,99)', lineHeight: '1.625', animation: 'fadeIn 0.5s ease-in' }}><ReactMarkdown>{section?.subtopics}</ReactMarkdown></div>
                                    </div>
                                )}
                                {section?.subtopics && !section?.articles?.stage === 'Started Mining Web...' && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                            <BreathingIcon />
                                            <h3 style={{ fontSize: '19px', fontWeight: 600, color: 'rgb(75,85,99)', position: 'relative' }}>
                                                Mining Articles based on Subtopics
                                                <img src={threedots} style={{ width: '30px', height: '30px', marginLeft: '-2px', position: 'absolute' }} />
                                            </h3>
                                        </div>
                                    </div>
                                )}
                                {section?.articles?.length > 0 && (
                                    <div style={{}}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            {section.articles && (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                                    <BreathingIconStatic />
                                                    <h3 style={{ fontSize: '19px', fontWeight: 600, color: 'rgb(75,85,99)' }}>
                                                        Mined Articles based on Subtopics:
                                                    </h3>
                                                </div>
                                            )}
                                        </div>
                                        {section?.articles?.length > 0 && (
                                            <button
                                                onClick={() => {
                                                    setHidearticleshook((prevState) => !prevState);
                                                    setViewInputButton((prevState) => !prevState);
                                                }}
                                                style={{ fontSize: '16.5px', color: 'rgb(37,99,235)', display: 'flex', alignItems: 'center', gap: '0.25rem' }}
                                            >
                                                <span>{viewInputButton ? 'Hide' : 'View all'}</span>
                                                <svg style={{ width: '1rem', height: '1rem', color: 'rgb(37,99,235)' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                                </svg>
                                            </button>
                                        )}
                                        {section?.articles?.length > 0 && (
                                            <div style={{ backgroundColor: 'rgba(75,85,99,0.05)', border: '1px solid rgba(75,85,99,0.2)', borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif', color: 'rgb(75,85,99)', lineHeight: '1.6' }}>
                                                {hidearticleshook &&
                                                    section?.articles?.map((item, idx) => {
                                                        const { title, snippet: description, link, source, date } = item;
                                                        return (
                                                            <div key={idx} style={{ marginBottom: '1.5rem', paddingBottom: '0px', lineHeight: '1.15' }}>
                                                                <h3 style={{ fontSize: '19px', fontWeight: 600, margin: '0 0 0.5rem', borderLeft: '4px solid rgb(75,85,99)', paddingLeft: '0.5rem', color: 'rgb(75,85,99)' }}>
                                                                    {title}
                                                                </h3>
                                                                <p style={{ margin: '0.5rem 0', fontSize: '16.5px' }}>{description}</p>
                                                                <p style={{ margin: '0.5rem 0', fontSize: '16.5px' }}>
                                                                    <strong>Source:</strong> {source} <br />
                                                                    <strong>Date:</strong> {date}
                                                                </p>
                                                            </div>
                                                        );
                                                    })}
                                                {!hidearticleshook &&
                                                    section?.articles?.slice(0, 5).map((item, idx) => {
                                                        const { title, snippet: description, link, source, date } = item;
                                                        return (
                                                            <div key={idx} style={{ marginBottom: '1.5rem', paddingBottom: '0px', lineHeight: '1.15' }}>
                                                                <h3 style={{ fontSize: '19px', fontWeight: 600, margin: '0 0 0.5rem', borderLeft: '4px solid rgb(75,85,99)', paddingLeft: '0.5rem', color: 'rgb(75,85,99)' }}>
                                                                    {title}
                                                                </h3>
                                                                <p style={{ margin: '0.5rem 0', fontSize: '16.5px' }}>{description}</p>
                                                                <p style={{ margin: '0.5rem 0', fontSize: '16.5px' }}>
                                                                    <strong>Source:</strong> {source} <br />
                                                                    <strong>Date:</strong> {date}
                                                                </p>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {section?.iterations && Object.values(section?.iterations).length > 0 && Object.values(section?.iterations).map((iter, idx) => (
                                    <div key={idx} style={{ paddingTop: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                        {iter.actorOutput && (
                                            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                <div style={{ maxWidth: '90%', backgroundColor: 'rgba(75,85,99,0.1)', borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', borderTopLeftRadius: '0.25rem', marginLeft: '0', marginRight: 'auto', lineHeight: '25.5px' }}>
                                                    {section?.actor === 'Deepseek' && (
                                                        <img src={deepseek} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', backgroundColor: 'rgb(158 158 158 / 20%)', position: 'absolute' }} />
                                                    )}
                                                    {section?.actor === 'Google Gemini' && (
                                                        <img src={gemini} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', backgroundColor: 'rgb(158 158 158 / 20%)', position: 'absolute' }} />
                                                    )}
                                                    {section?.actor === 'Anthropic' && (
                                                        <img src={claude} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', backgroundColor: 'rgb(158 158 158 / 20%)', position: 'absolute' }} />
                                                    )}
                                                    <h4 style={{ margin: '0 0 0.25rem', fontSize: '19px', fontWeight: 600, color: 'rgb(75,85,99)' }}>
                                                        {section?.actor === 'Deepseek' && <>(Deepseek) Initial Output</>}
                                                        {section?.actor === 'Google Gemini' && <>(Google Gemini) Initial Output</>}
                                                        {section?.actor === 'Anthropic' && <>(Anthropic Claude) Initial Output</>}
                                                    </h4>
                                                    <p style={{ margin: '0.5rem 0', fontSize: '16.5px', color: 'rgb(75,85,99)', animation: 'fadeIn 0.5s ease-in' }}><ReactMarkdown>{iter.actorOutput}</ReactMarkdown></p>
                                                </div>
                                            </div>
                                        )}
                                        {iter.criticFeedback && (
                                            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                <div style={{ maxWidth: '90%', backgroundColor: 'rgba(75,85,99,0.1)', borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', borderTopLeftRadius: '0.25rem', marginLeft: '0', marginRight: 'auto', lineHeight: '25.5px' }}>
                                                    {section?.actor === 'Deepseek' && (
                                                        <img src={deepseek} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', backgroundColor: 'rgb(158 158 158 / 20%)', position: 'absolute' }} />
                                                    )}
                                                    {section?.actor === 'Google Gemini' && (
                                                        <img src={gemini} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', backgroundColor: 'rgb(158 158 158 / 20%)', position: 'absolute' }} />
                                                    )}
                                                    {section?.actor === 'Anthropic' && (
                                                        <img src={claude} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', backgroundColor: 'rgb(158 158 158 / 20%)', position: 'absolute' }} />
                                                    )}
                                                    <h4 style={{ margin: '0 0 0.25rem', fontSize: '19px', fontWeight: 600, color: 'rgb(75,85,99)' }}>
                                                        {section?.actor === 'Deepseek' && <>(Deepseek) Critic Feedback</>}
                                                        {section?.actor === 'Google Gemini' && <>(Google Gemini) Critic Feedback</>}
                                                        {section?.actor === 'Anthropic' && <>(Anthropic Claude) Critic Feedback</>}
                                                    </h4>
                                                    <p style={{ margin: '0.5rem 0', fontSize: '16.5px', color: 'rgb(75,85,99)', animation: 'fadeIn 0.5s ease-in' }}><ReactMarkdown>{iter.criticFeedback}</ReactMarkdown></p>
                                                </div>
                                            </div>
                                        )}
                                        {iter.refinedAnalysis && (
                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <div style={{ maxWidth: '90%', backgroundColor: 'rgba(75,85,99,0.2)', borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', borderTopRightRadius: '0.25rem', marginLeft: 'auto', marginRight: '0', lineHeight: '25.5px' }}>
                                                    {section?.critic === 'Deepseek' && (
                                                        <img src={deepseek} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', padding: '3px', position: 'absolute' }} />
                                                    )}
                                                    {section?.critic === 'Google Gemini' && (
                                                        <img src={gemini} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', backgroundColor: 'rgb(158 158 158 / 20%)', position: 'absolute' }} />
                                                    )}
                                                    {section?.critic === 'Anthropic' && (
                                                        <img src={claude} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', backgroundColor: 'rgb(158 158 158 / 20%)', position: 'absolute' }} />
                                                    )}
                                                    <h4 style={{ margin: '0 0 0.25rem', fontSize: '19px', fontWeight: 600, color: 'rgb(75,85,99)' }}>
                                                        {section?.critic === 'Deepseek' && <>(Deepseek) Refined Analysis</>}
                                                        {section?.critic === 'Google Gemini' && <>(Google Gemini) Refined Analysis</>}
                                                        {section?.critic === 'Anthropic' && <>(Anthropic Claude) Refined Analysis</>}
                                                    </h4>
                                                    <p style={{ margin: '0.5rem 0', fontSize: '16.5px', color: 'rgb(75,85,99)', animation: 'fadeIn 0.5s ease-in' }}><ReactMarkdown>{iter.refinedAnalysis}</ReactMarkdown></p>
                                                </div>
                                            </div>
                                        )}
                                        {iter.timestamp && (
                                            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                                <div style={{ maxWidth: '60%', backgroundColor: 'rgba(75,85,99,0.1)', borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', borderTopLeftRadius: '0.25rem', marginLeft: '0', marginRight: 'auto' }}>
                                                    <h4 style={{ margin: '0 0 0.25rem', fontSize: '16.5px', color: 'rgb(75,85,99)' }}>Timestamp</h4>
                                                    <p style={{ margin: '0.5rem 0', fontSize: '16.5px', color: 'rgb(75,85,99)' }}>{new Date(iter.timestamp).toLocaleString()}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                                {section?.finalSummary && (
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <div style={{ maxWidth: '90%', backgroundColor: 'rgba(75,85,99,0.2)', borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', marginLeft: 'auto', marginRight: '0', lineHeight: '25.5px', marginTop: '17px' }}>
                                            {section?.critic === 'Deepseek' && (
                                                <img src={deepseek} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', padding: '3px', position: 'absolute' }} />
                                            )}
                                            {section?.critic === 'Google Gemini' && (
                                                <img src={gemini} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', backgroundColor: 'rgb(158 158 158 / 20%)', position: 'absolute' }} />
                                            )}
                                            {section?.critic === 'Anthropic' && (
                                                <img src={claude} style={{ width: '45px', height: '45px', marginLeft: '-80px', borderRadius: '15px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid rgba(75,85,99,0.2)', backgroundColor: 'rgb(158 158 158 / 20%)', position: 'absolute' }} />
                                            )}
                                            <h4 style={{ margin: '0 0 0.25rem', fontSize: '19px', fontWeight: 600, color: 'rgb(75,85,99)' }}>
                                                {section?.critic === 'Deepseek' && <>(Deepseek) Final Summary</>}
                                                {section?.critic === 'Google Gemini' && <>(Google Gemini) Final Summary</>}
                                                {section?.critic === 'Anthropic' && <>(Anthropic Claude) Final Summary</>}
                                            </h4>
                                            <p style={{ margin: '0.5rem 0', fontSize: '16.5px', color: 'rgb(75,85,99)', animation: 'fadeIn 0.5s ease-in' }}><ReactMarkdown>{section?.finalSummary}</ReactMarkdown></p>
                                        </div>
                                    </div>
                                )}
                                {section?.error && (
                                    <div style={{ paddingTop: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
                                        <div style={{ maxWidth: '60%', backgroundColor: 'rgba(75,85,99,0.2)', borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', borderTopRightRadius: '0.25rem', marginLeft: 'auto', marginRight: '0', alignItems: "center", justifyContent: 'flex-end', marginRight: "5px" }}>
                                            <span style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginRight: "5px" }}>
                                                {section.error === true && <ErrorOutlineOutlinedIcon color="grey" size="16px" />}
                                                <h4 style={{ fontSize: '16.5px', fontWeight: 600, color: 'rgb(75,85,99)', marginRight: '5px', marginLeft: '10px' }}>Stage:</h4>
                                                <p style={{ margin: '0.5rem 0', fontSize: '16.5px', color: 'rgb(75,85,99)' }}>Process stopped gracefully</p>
                                            </span>
                                        </div>
                                    </div>
                                )}
                                {section?.loading && (
                                    <div style={{ paddingTop: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
                                        <div style={{ maxWidth: '60%', backgroundColor: 'rgba(75,85,99,0.2)', borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', borderTopRightRadius: '0.25rem', marginLeft: 'auto', marginRight: '0', alignItems: "center", justifyContent: 'flex-end', marginRight: "5px" }}>
                                            <span style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginRight: "5px" }}>
                                                {section.stage !== "Completed" && <CircularProgress color="grey" size="16px" />}
                                                {section.stage === "Completed" && <DoneIcon color="grey" size="16px" />}
                                                <h4 style={{ fontSize: '16.5px', fontWeight: 600, color: 'rgb(75,85,99)', marginRight: '5px', marginLeft: '10px' }}>Stage:</h4>
                                                <p style={{ margin: '0.5rem 0', fontSize: '16.5px', color: 'rgb(75,85,99)' }}>{section.stage}</p>
                                            </span>
                                        </div>
                                    </div>
                                )}
                                {section?.stage === "Completed" && (
                                    <div style={{ paddingTop: '1rem', display: 'flex', justifyContent: 'flex-end' }}>
                                        <div style={{ maxWidth: '60%', backgroundColor: 'rgba(75,85,99,0.2)', borderRadius: '0.75rem', padding: '1rem', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', borderTopRightRadius: '0.25rem', marginLeft: 'auto', marginRight: '0', alignItems: "center", justifyContent: 'flex-end', marginRight: "5px" }}>
                                            <span style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", marginRight: "5px" }}>
                                                {section.stage !== "Completed" && <CircularProgress color="grey" size="16px" />}
                                                {section.stage === "Completed" && <DoneIcon color="grey" size="16px" />}
                                                <h4 style={{ fontSize: '16.5px', fontWeight: 600, color: 'rgb(75,85,99)', marginRight: '5px', marginLeft: '10px' }}>Stage:</h4>
                                                <p style={{ margin: '0.5rem 0', fontSize: '16.5px', color: 'rgb(75,85,99)' }}>{section.stage}</p>
                                            </span>
                                        </div>
                                    </div>
                                )}
                                {section?.timout_err && !section?.error && (
                                    <div style={{ paddingTop: '1rem', display: 'flex' }}>
                                        <div style={{ width: '100%', backgroundColor: 'red', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', marginLeft: 'auto', marginRight: '0', alignItems: "flex-start", justifyContent: 'flex-end', marginRight: "5px", paddingLeft: '15px', paddingRight: '15px' }}>
                                            <span style={{ display: "flex", flexDirection: "row", alignItems: "center", marginRight: "5px" }}>
                                                <p style={{ margin: '0.5rem 0', fontSize: '15px', color: 'white', fontFamily: 'Arial' }}>
                                                    <br />
                                                    <span style={{ margin: '0.5rem 0', fontSize: '15px', fontWeight: '700', color: 'white', fontFamily: 'Arial' }}>Invalid API or Connection Error: Retrying in 2 secs or click refresh to start again!</span>
                                                </p>
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    <div ref={bottomRef} />
                </div>
            )}
            <span style={{ position: "fixed", right: "10vw", bottom: "10vh", zIndex: 1000 }}>
                <Fab aria-label="downIcon" onClick={() => window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' })}>
                    <ExpandMoreIcon />
                </Fab>
            </span>
        </div>
    );
}

export default Landingpage;